var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBgBlueRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#5062F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6464 8.14645C15.8417 7.95118 16.1583 7.95118 16.3536 8.14645L20.5202 12.3131C20.7155 12.5084 20.7155 12.825 20.5202 13.0202C20.325 13.2155 20.0084 13.2155 19.8131 13.0202L16.5 9.70711V18.5C16.5 18.7761 16.2761 19 16 19C15.7239 19 15.5 18.7761 15.5 18.5V9.70711L12.1869 13.0202C11.9916 13.2155 11.675 13.2155 11.4798 13.0202C11.2845 12.825 11.2845 12.5084 11.4798 12.3131L15.6464 8.14645ZM8.5 18C8.77614 18 9 18.2239 9 18.5V21.8333C9 22.1428 9.12292 22.4395 9.34171 22.6583C9.5605 22.8771 9.85725 23 10.1667 23H21.8333C22.1428 23 22.4395 22.8771 22.6583 22.6583C22.8771 22.4395 23 22.1428 23 21.8333V18.5C23 18.2239 23.2239 18 23.5 18C23.7761 18 24 18.2239 24 18.5V21.8333C24 22.408 23.7717 22.9591 23.3654 23.3654C22.9591 23.7717 22.408 24 21.8333 24H10.1667C9.59203 24 9.04093 23.7717 8.6346 23.3654C8.22827 22.9591 8 22.408 8 21.8333V18.5C8 18.2239 8.22386 18 8.5 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBgBlueRounded);
export default __webpack_public_path__ + "static/media/uploadBgBlueRounded.a0561d4ba37c44617982574b2ea43d90.svg";
export { ForwardRef as ReactComponent };